import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, TextField, Typography } from "@material-ui/core";
import Message from "./Message";
import { ExpandMore } from "@material-ui/icons";
import { useState } from "react";

export default function Chat(props) {
  const [isSIConfigOpen, setIsSIConfigOpen] = useState(false);

  const messages = props.sessionHistory?.map(m => {
    return (
      <Message
        key={m.messageId}
        messageData={m.content.data}
        message={m}
        type={m.content.type}
        role={m.content.role}
        id={m.messageId}
        tokenCount={m.tokenCount}
        thinkingTokenCount={m.thinkingTokenCount}
        filename={m.content.filename}
        deleteMessage={(messageId) => props.deleteMessage(messageId)}
      />
    )
  })

  return (
    <Grid item xs={12} md={12} lg={12} container spacing={3} style={{backgroundColor: "#f5f5f5", borderRadius: "10px", margin: "10px 0px 0px"}}>
      <Grid item xs={12} md={12} lg={12}>
        <Typography variant="h6"><b>Session Stats</b></Typography>
        <Typography>Token Count: {props.tokenCount}</Typography>
        <Typography>Message Count: {props.sessionHistory?.length ?? 0}</Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12} style={{position: "relative", height: "70px"}}>
        <div style={{position: "absolute", top: "0px", left: "0px", right: "0px", bottom: "0px", zIndex: "5", padding: "0px 13px"}}>
            <Accordion elevation={4} expanded={isSIConfigOpen} style={{backgroundColor: "#FFFFFF", borderRadius: "10px", boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)"}}>
              <AccordionSummary
                expandIcon={<ExpandMore/>}
                aria-controls="sample-content"
                id="sample-header"
                style={{borderRadius: "10px"}}
                onClick={() => setIsSIConfigOpen(!isSIConfigOpen)}
              >
                <Typography variant="h5">System Instructions</Typography>
              </AccordionSummary>
              <AccordionDetails style={{display: "block", padding: "20px 10px", borderRadius: "10px"}}>
                <TextField 
                  value={props.systemInstructions} 
                  multiline 
                  fullWidth
                  inputProps={{
                    style: { padding: "10px" }
                  }}
                  onChange={(e) => props.setSystemInstructions(e.target.value)}
                  style={{maxHeight: "400px", overflowY: "scroll", whiteSpace: "pre-wrap", wordBreak: "break", backgroundColor: "#f5f5f5"}}
                />
              </AccordionDetails>
            </Accordion>
          </div>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <div style={{border: "1px solid #b9b9b9", backgroundColor: "#FFFFFF", overflowY: "scroll", borderRadius: "10px", minHeight: "600px", maxHeight: "60vh", padding: "15px 0px"}}>
          <Grid container style={{padding: "10px 15px 10px 20px"}}>
            {messages}
          </Grid>
        </div>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <div style={{border: "1px solid #b9b9b9", backgroundColor: "#FFFFFF"}}>
          <TextField 
            value={props.message} 
            multiline 
            fullWidth
            inputProps={{
              style: { padding: "10px" }
            }}
            onChange={(e) => props.setMessage(e.target.value)}
            style={{maxHeight: "200px", overflowY: "scroll", whiteSpace: "pre-wrap", wordBreak: "break", backgroundColor: "#FFFFFF"}}
          />
        </div>
      </Grid>
      <Grid item xs={12} md={12} lg={12} style={{textAlign: "right"}}>
        <Button 
          variant="contained"
          onClick={() => props.sendMessage()}
          style={{backgroundColor: "#142e3e", color: "#28c4fc"}}
        >
          Submit
        </Button> 
      </Grid>
    </Grid>
  )
}